const GRID_MODE = 'GRID_MODE';
const PIN_MODE = 'PINNED_MODE';
const VAD_MODE = 'VAD_MODE';
const SEMINAR_MODE = 'SEMINAR_MODE';

const SCREEN_SHARE_MODE = 'shared_screen';
const DOCUMENT_SHARE_MODE = 'document';
const WHITE_BOARD_MODE = 'whiteboard';
const COMMON_NOTE = 'common_note';
const VOD_MODE = 'vod';

export const videoLayoutMode = {
    default: GRID_MODE,
    grid: GRID_MODE,
    document: DOCUMENT_SHARE_MODE,
    pin: PIN_MODE,
    seminar: SEMINAR_MODE,
    screen: SCREEN_SHARE_MODE,
    white: WHITE_BOARD_MODE,
    voice: VAD_MODE,    
    note: COMMON_NOTE,
    vod: VOD_MODE,
};

export const layoutType = {
    desktop: 'desktop',
    tablet: 'tablet',
    mobile: 'mobile'
}

export const PAGING_TYPE = {
    PREV: 'previous',
    NEXT: 'next'
}

export const shareLayoutList = [
    SCREEN_SHARE_MODE, DOCUMENT_SHARE_MODE, WHITE_BOARD_MODE, VOD_MODE, COMMON_NOTE
];
export const documentLayoutList = [
    WHITE_BOARD_MODE, DOCUMENT_SHARE_MODE, COMMON_NOTE, VOD_MODE
];
export const layoutList = [
    GRID_MODE, PIN_MODE, VAD_MODE, SEMINAR_MODE
];

export const horizontalModeList = [
    ...documentLayoutList, VAD_MODE, PIN_MODE, SEMINAR_MODE
];
